module.exports = __webpack_public_path__ + "media/assets/community/twitter-logo-469078c62c4e5c885ed5888792b25d92f8fa6bd1489c5e66dde51038e24b0268.png";